import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Youtube } from "lucide-react";
import { useNavigate } from 'react-router-dom';
import { Badge } from "@/components/ui/badge";

interface YouTubeSuggestionsCardProps {
    youtubeSuggestionsCount?: number;
}

const YouTubeSuggestionsCard: React.FC<YouTubeSuggestionsCardProps> = ({ youtubeSuggestionsCount }) => {
    const navigate = useNavigate();

    return (
        <Card className="bg-gray-800 text-secondary-foreground border-border shadow-md hover:shadow-primary/30 transition-shadow duration-300">
            <CardHeader className="flex flex-row items-center justify-between pb-0">
                <CardTitle className="text-xl font-bold text-primary">YouTube Ajánlások</CardTitle>
                {youtubeSuggestionsCount !== undefined && youtubeSuggestionsCount > 0 && (
                    <Badge variant="destructive">{youtubeSuggestionsCount}</Badge>
                )}
            </CardHeader>
            <CardContent className="flex flex-col items-center justify-center p-6">
                <Youtube size={48} className="text-red-500 mb-4" />
                <Button
                    variant="outline"
                    onClick={() => navigate("/admin/youtube-suggestions")}
                    className="w-full bg-muted text-muted-foreground border-border hover:bg-secondary hover:text-secondary-foreground"
                >
                    Ajánlások kezelése
                </Button>
            </CardContent>
        </Card>
    );
};

export default YouTubeSuggestionsCard;
